import React from 'react'
import PropTypes from 'prop-types'
import Tick from './tick'
import TickLabel from './tickLabel'

class ProgressBar extends React.Component {

  constructor (props) {
    super (props)
    this.state = {
      progress: "0",
      color: this.props.color,
      benefitStates: this.props.benefitStates
    }
  }

  componentDidMount () {
    let start = Date.now()
    const progressInterval = setInterval ( () => {

      this.state.benefitStates.map ( this.setBenefitState.bind(this))
      let progress = (Date.now() - start) / 50
      if (Number(this.state.progress) > 100) {
        clearInterval(progressInterval)
        setTimeout( (() => {
          this.props.showNext(this.props.benefits, this.props.id)
        }).bind(this), 2500)
      }
      this.setState({
          progress: progress + 0.5
      })
    }, this.props.speed)
  }

  setBenefitState (benefitState, i) {
    ( this.state.progress > 34 + ((benefitState.number-1)*33) ) &&
    this.setTickState (this.props.benefit, i)
    return
  }

  getBenefitLabel (index) {
    const labels = [
      this.props.paidLeaveSubstitution || "Paid",
      this.props.jobProtectedLeaveSubstitution || "Job Protection",
      "Additional"
    ]
    return labels[index]
  }

  setTickState (benefit, i) {
    const benefits = this.state.benefitStates
    const benefitState = benefits[i]
    benefits[i] = {
        name: benefitState.name,
        number: benefitState.number,
        state: true,
        label: benefitState.label
                .replace("<benefitLabel>", this.getBenefitLabel(benefit.index))
                .replace("<number>", benefit.number)
    }
    this.setState({
      ...this.state,
      benefitStates: benefits
    })
  }

  renderTick (type, index) {
    if (type.state) {
      return (
        <div
          key={index}
          className="tick-outer"
          style={{
            left: Number(type.number) * 32 + "%"
          }}>
          <Tick color={this.state.color} />
        </div>
      )
     }
  }

  renderTickLabel (type, index) {
    if (type.state) {
      return (
        <div
          key={index}
          className="tick-label-container"
          style={{
            left: (Number(type.number) * 32) - 9.5 + "%"
          }}>
          <TickLabel
            text={type.label}
            pluralize={this.props.pluralize}
          />
        </div>
      )
    }
  }

  render () {

    const style = {
      progressStyle: {
        height: "100%",
        width: this.state.progress + "%",
        backgroundColor: this.state.color
      }
    }

    return (
      <div className="dashbuild-progressbar-tile">
        {
          this.state.benefitStates.map ( ((foundState, index) =>  {
            return this.renderTick (foundState, index)
          }).bind(this))
        }
        {
          this.state.benefitStates.map ( ((foundState, index) =>  {
            return this.renderTickLabel (foundState, index)
          }).bind(this))
        }
        <div className="dashbuild-progress-bar">
          <div
            className="dashbuild-progress"
            style={style.progressStyle}>
          </div>
        </div>
      </div>
    )
  }
}

export default ProgressBar;

